import { Controller } from '@hotwired/stimulus'

// Submits a GET filter form without jumping to the top of the page.
// Also toggles the compact filters panel.
export default class extends Controller {
  static values = {
    anchor: String,
    open: { type: Boolean, default: false }
  }

  static targets = ['panel', 'toggle', 'chevron', 'badge']

  connect () {
    this.syncPanel()
  }

  togglePanel (event) {
    if (event) event.preventDefault()
    this.openValue = !this.openValue
    this.syncPanel()
  }

  openValueChanged () {
    this.syncPanel()
  }

  syncPanel () {
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.toggle('hidden', !this.openValue)

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute('aria-expanded', this.openValue ? 'true' : 'false')
    }

    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle('rotate-180', this.openValue)
    }
  }

  submit (event) {
    if (event && event.type === 'submit') event.preventDefault()

    const form = this.formElement()
    if (!form) return

    const url = this.buildUrl(form)
    const anchorId = this.hasAnchorValue && this.anchorValue ? this.anchorValue : null

    if (window.Turbo) {
      const visit = window.Turbo.visit(url, { action: 'advance' })
      if (visit && typeof visit.then === 'function') {
        visit.then(() => {
          if (anchorId) this.scrollToAnchor(anchorId)
        })
      } else if (anchorId) {
        this.scrollToAnchor(anchorId)
      }
    } else if (form.requestSubmit) {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }

  formElement () {
    if (this.element.tagName === 'FORM') return this.element
    return this.element.querySelector('form')
  }

  scrollToAnchor (id) {
    const target = document.getElementById(id)
    if (!target) return

    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }

  buildUrl (form) {
    const action = (form.getAttribute('action') || window.location.pathname).split('#')[0]
    const params = new URLSearchParams()

    for (const [key, value] of new FormData(form).entries()) {
      if (value !== null && value !== '') params.append(key, value)
    }

    const query = params.toString()
    const hash = this.hasAnchorValue && this.anchorValue ? `#${this.anchorValue}` : ''
    return `${action}${query ? `?${query}` : ''}${hash}`
  }
}
